import { AppRoutes } from 'config';
import { useHeader } from 'context';
import { Customers } from 'components';
import { useAppSelector } from 'store';
import { BackOfficeRoles } from 'types';
import { selectAuthUser } from 'store/slices/auth';

const disabledSelectEmployeeRoles = [
  BackOfficeRoles.MANAGER,
  BackOfficeRoles.SALES_REP,
];

export const Create = () => {
  const authUser = useAppSelector(selectAuthUser);

  const isDisabledSelectOtherEmployee = disabledSelectEmployeeRoles.includes(
    authUser?.role?.name as BackOfficeRoles
  );

  useHeader({
    showBackButton: true,
    pageName: 'New customer',
  });

  return (
    <Customers.Create
      navigateUrl={AppRoutes.Customers.Home}
      employeeOptions={
        isDisabledSelectOtherEmployee
          ? [
              {
                label: authUser?.name || '',
                value: authUser?.id ? String(authUser.id) : '',
              },
            ]
          : undefined
      }
    />
  );
};
